import { render, staticRenderFns } from "./ProjectDesignAndCustomer.vue?vue&type=template&id=448c0a3e&scoped=true&"
import script from "./ProjectDesignAndCustomer.vue?vue&type=script&lang=js&"
export * from "./ProjectDesignAndCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDesignAndCustomer.vue?vue&type=style&index=0&id=448c0a3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448c0a3e",
  null
  
)

export default component.exports